// src/ChangeRoleIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ChangeRoleIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "52",
    height: "40",
    viewBox: "0 0 52 40",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.58243 13.6631C8.27458 12.9714 9.39666 12.9712 10.0887 13.6631L15.752 19.3281L15.8748 19.4631C16.4419 20.1592 16.4006 21.1857 15.752 21.8343C15.1032 22.4816 14.078 22.5222 13.3824 21.9555L13.2457 21.8343L10.1164 18.705C10.0707 19.4824 10.0536 20.3579 10.0991 21.2908C10.2668 24.7273 11.2384 28.7494 14.2617 31.7727C14.6583 32.1693 15.0715 32.5396 15.4975 32.8857C16.3439 28.9868 20.5219 26.0317 25.5415 26.0316C30.5609 26.0318 34.7372 28.987 35.5838 32.8857C36.0103 32.5394 36.4244 32.1696 36.8213 31.7727C37.5135 31.0806 38.6355 31.0806 39.3276 31.7727C40.019 32.4649 40.0194 33.587 39.3276 34.279C31.7175 41.8885 19.3654 41.8886 11.7555 34.279C7.86187 30.3854 6.74764 25.3521 6.55778 21.4639C6.52836 20.8605 6.52346 20.2773 6.53182 19.7262L3.82307 22.4366C3.13101 23.1276 2.00695 23.1279 1.3151 22.4366C0.623626 21.745 0.624644 20.6226 1.3151 19.9304L7.58243 13.6631Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.7555 6.70684C19.3623 -0.899942 31.6641 -0.956652 39.3276 6.70684C43.8788 11.2582 45.3836 16.5681 45.7559 20.685C45.821 21.4055 45.8517 22.0927 45.858 22.7343L48.6516 19.9408C49.3437 19.2492 50.4658 19.249 51.1578 19.9408C51.8497 20.6328 51.8494 21.7548 51.1578 22.447L44.8922 28.7144C44.2002 29.4055 43.0779 29.4055 42.386 28.7144L36.8213 23.148C36.1299 22.456 36.1299 21.3338 36.8213 20.6418C37.5134 19.9509 38.6358 19.9505 39.3276 20.6418L42.3029 23.6171C42.3249 22.8372 42.3109 21.9541 42.225 21.0035C41.9045 17.4604 40.6281 13.02 36.8213 9.21309C30.5487 2.94043 20.4908 2.98407 14.2617 9.21309C13.5695 9.90472 12.4475 9.90499 11.7555 9.21309C11.0636 8.52109 11.0639 7.39898 11.7555 6.70684Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.5415 10.5908C28.8206 10.5912 31.4797 13.2502 31.48 16.5293C31.4797 19.8084 28.8206 22.4674 25.5415 22.4678C22.2622 22.4677 19.6034 19.8086 19.603 16.5293C19.6034 13.25 22.2622 10.5909 25.5415 10.5908Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var ChangeRoleIcon_default = ChangeRoleIcon;

export {
  ChangeRoleIcon_default
};
